import axios from '@/clientAPI.ts'
import axiosV3 from '@/clientAPIV3'
import {Message} from '@/features/common/types'
import * as types from '../types'

export const MICROMORGI_API = {
    getMicromorgiTransactions: async (
        params: types.GetMicromorgiTransactionsParams
    ): Promise<types.TransactionPage> => {
        const {data} = await axios.get('/transactions/micromorgi', {params})
        return data
    },
    sendRequestToGetUltimateStatus: async (): Promise<types.PaymentUrls | Message> => {
        const {data} = await axios.post(`/offer/ultimate-offer/buy`)
        return data
    }
}

export const getMicromorgiPackagesV3 = async (): Promise<types.MicromorgiPackagesV3> => {
    const {data} = await axiosV3.get(`/micromorgi-packages`)
    return data
}

export const buyMicromorgiPackageV3 = async ({
    packageId,
    campaignId,
    onlyLinks
}: types.BuyMicromorgiPackageParamsV3): Promise<types.PaymentUrls | Message> => {
    const {data} = await axiosV3.post(`/micromorgi-packages/${packageId}/buy`, {
        campaignId: campaignId,
        onlyLinks
    })
    return data
}

export const sendMicromorgiV3 = async ({
    creatorId,
    ...body
}: types.SendMicromorgiParamsV3): Promise<{message: string}> => {
    const {data} = await axiosV3.post(`/micromorgi/${creatorId}/send`, body)
    return data
}
